export default __webpack_public_path__ + "static/media/WfsSearch.c9779ce6.less";